import { searchApplicants, searchCandidates } from '~/api/v2';
import { useSearch } from '~/components/QuickNav/useSearch';

const RESULT_LIMIT = 5;

function findCandidates(query: string, signal?: AbortSignal) {
    return searchCandidates({ query: { query, limit: RESULT_LIMIT }, signal });
}

function findApplicants(query: string, signal?: AbortSignal) {
    return searchApplicants({ query: { query, limit: RESULT_LIMIT }, signal });
}

export function useCandidateSearch(query: string, enabled: boolean) {
    const { results, pending, failed } = useSearch(query, enabled, findCandidates);
    return { candidates: results, pending, failed };
}

export function useApplicantSearch(query: string, enabled: boolean) {
    const { results, pending, failed } = useSearch(query, enabled, findApplicants);
    return { applicants: results, pending, failed };
}
